import { useState } from "react";
import { Copy, Check, Facebook, Twitter, Linkedin } from "lucide-react";
import { toast } from "sonner";

export const ArticleShareButtons = ({ title, url }) => {
  const [copied, setCopied] = useState(false);
  const encoded = encodeURIComponent(url || "");
  const enTitle = encodeURIComponent(title || "");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 1600);
    } catch {
      toast.error("Couldn't copy — try selecting the URL");
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="article-share-buttons">
      <button
        onClick={copy}
        className="inline-flex items-center gap-2 h-9 px-3 rounded-lg bg-secondary hover:bg-secondary/80 text-sm font-medium transition"
        data-testid="article-share-copy"
        aria-label="Copy link"
      >
        {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
        {copied ? "Copied" : "Copy link"}
      </button>
      <a
        href={`https://twitter.com/intent/tweet?url=${encoded}&text=${enTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 rounded-lg bg-secondary hover:bg-secondary/80 inline-flex items-center justify-center transition"
        aria-label="Share on X"
        data-testid="article-share-twitter"
      >
        <Twitter className="w-4 h-4" />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encoded}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 rounded-lg bg-secondary hover:bg-secondary/80 inline-flex items-center justify-center transition"
        aria-label="Share on Facebook"
        data-testid="article-share-facebook"
      >
        <Facebook className="w-4 h-4" />
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-9 h-9 rounded-lg bg-secondary hover:bg-secondary/80 inline-flex items-center justify-center transition"
        aria-label="Share on LinkedIn"
        data-testid="article-share-linkedin"
      >
        <Linkedin className="w-4 h-4" />
      </a>
    </div>
  );
};
